import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { LocalStorageTodoService } from "../../services/localstorage/localstorage-todo.service";
import { Task } from './task.models';

@Component({
    selector: "app-todo",
    templateUrl: "./todo.component.html",
    styleUrls: ["./todo.component.scss"],
    providers: [],
    standalone: false
})
export class TodoComponent implements OnInit
{
	tasks: Task[];
	form: UntypedFormGroup;
	isSubmitted = false;
	triggerToggleInput = true;

	@ViewChild('NewTaskFormChild') newTaskFormChild;

	constructor(private todoService: LocalStorageTodoService, fb: UntypedFormBuilder)
	{
		this.form = fb.group({
			newTask: new UntypedFormControl("", [Validators.required])
		});
	}

	ngOnInit()
	{
		this.todoService.getAll().then(tasks =>
		{
			this.tasks = tasks;
		});
	}

	onSubmit({ value, valid }: { value: UntypedFormGroup; valid: boolean })
	{
		this.isSubmitted = true;

		if (!valid)
		{
			return;
		}

		this.todoService
			.add(this.form.get("newTask").value)
			.then(() =>
			{
				return this.todoService.getAll();
			})
			.then(tasks =>
			{
				this.tasks = tasks;
				this.form.setValue({
					newTask: ""
				});
				this.newTaskFormChild.resetForm();
				this.triggerToggleInput = true;
				this.isSubmitted = false;
			});
	}

	onNotify()
	{
		this.todoService.getAll().then(tasks =>
		{
			this.tasks = tasks;
		});
	}
}
